import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState } from 'react';
import { useFormContext, } from 'react-hook-form';
import { defaultVisitors } from '@genericBookings/types/Visitors';
import StyledForm from '@bookingForm/styles/form';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import { useStepCompletion } from '@widgets/DayTickets/context/Steps';
function Bundles({ options }) {
    const { setValue } = useFormContext();
    const { attendeesStep } = useStepCompletion();
    const onHandleBundleSelected = useGlobalEvent('bundle.select');
    const [bundleName, setBundleName] = useState(null);
    onHandleBundleSelected((ev) => {
        const { visitors: bundleVisitors, name } = ev.detail;
        Object.keys(bundleVisitors).forEach((key, idx) => {
            setValue(`Visitors${idx}`, bundleVisitors[key]);
        });
        setBundleName(name);
    });
    if (!bundleName) {
        return null;
    }
    return (_jsx(StyledForm.BundleWrapper, { children: _jsxs("span", { className: "tag", children: ["Currently selected bundle:\u00A0", bundleName, !attendeesStep.isComplete && (_jsx("button", { onClick: () => {
                        setBundleName(null);
                        // resetting the visitors back to 0 if clicked.
                        Object.keys(defaultVisitors).forEach((visitor, idx) => {
                            setValue(visitor, defaultVisitors[visitor]);
                        });
                        window.dispatchEvent(new CustomEvent('bundle.reset'));
                    }, type: "button", className: "blank-btn", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }))] }) }));
}
export default Bundles;
